import { render, staticRenderFns } from "./UserBackgroundTable.vue?vue&type=template&id=54a7488c&scoped=true&"
import script from "./UserBackgroundTable.vue?vue&type=script&lang=js&"
export * from "./UserBackgroundTable.vue?vue&type=script&lang=js&"
import style0 from "./UserBackgroundTable.vue?vue&type=style&index=0&id=54a7488c&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54a7488c",
  null
  
)

export default component.exports